import "./SelectedAddressCard.css";

import {
  User,
  Phone,
  House,
  Mail,
  CheckCircle2,
  Plus,
  ArrowLeft,
} from "lucide-react";

export default function SelectedAddressCard({
  address,

  onChange,

  onCreate,
}) {
  if (!address) {
    return (
      <div className="selected-address-empty">هیچ آدرسی انتخاب نشده است.</div>
    );
  }

  return (
    <div className="selected-address-card">
      <div className="selected-address-badge">
        <CheckCircle2 size={18} />

        <span>آدرس انتخاب شده</span>
      </div>

      <div className="selected-address-top">
        <div className="selected-user-avatar">
          <User size={34} />
        </div>

        <div className="selected-user-info">
          <h3>
            {address.fname} {address.lname}
          </h3>

          <div className="selected-phone">
            <Phone size={16} />

            {address.mobile}
          </div>
        </div>
      </div>

      <div className="selected-address-body">
        <div className="address-row">
          <House size={17} />

          <span>
            {address.province}
            {"، "}
            {address.city}
            {"، "}
            {address.address}
          </span>
        </div>

        <div className="address-row">
          <Mail size={17} />

          <span>کد پستی: {address.postal_code}</span>
        </div>
      </div>

      <div className="selected-address-actions">
        <button className="btn-outline" onClick={onChange}>
          <ArrowLeft size={18} />
          تغییر آدرس
        </button>

        <button className="btn-dashed" onClick={onCreate}>
          <Plus size={18} />
          ثبت آدرس جدید
        </button>
      </div>
    </div>
  );
}
